import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DragHandleIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DragHandleIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/drag-handle">
            <rect x="9" y="6" width="2" height="2" rx="1" fill="currentColor" />
            <rect x="13" y="6" width="2" height="2" rx="1" fill="currentColor" />
            <rect x="9" y="11" width="2" height="2" rx="1" fill="currentColor" />
            <rect x="13" y="11" width="2" height="2" rx="1" fill="currentColor" />
            <rect x="9" y="16" width="2" height="2" rx="1" fill="currentColor" />
            <rect x="13" y="16" width="2" height="2" rx="1" fill="currentColor" />
        </g>
    </SvgIcon>
)
